const StageOrientation = {
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  NONE: 'none',
};

function getOrientationFromSeatValue(value_) {
  const value = value_.toLowerCase();

  if (Object.values(StageOrientation).includes(value)) {
    return value;
  }

  return StageOrientation.NONE;
}

export default StageOrientation;

export {
  getOrientationFromSeatValue,
};



// WEBPACK FOOTER //
// ./V7/syos/StageOrientation.js